export const DEFAULT_PAGINATION_LIMIT = 20;
export const MIN_PASSWORD_LENGTH = 8;
export const OTP_LENGTH = 6;

export const STORAGE_AUTH_TOKEN_KEY = "auth-token-key";
export const STORAGE_REFRESH_TOKEN_KEY = "refresh-token-key";
export const SERVER_SECRET_KEY = "x-server-secret";
export const THEME_DARK_VALUE = "dark";
export const THEME_LIGHT_VALUE = "light";
export const THEME_COLOR_MODE_KEY = "THEME_COLOR_MODE";
export const IS_ANNOUNCEMENT_BAR_VISIBLE_KEY =
  "IS_ANNOUNCEMENT_BAR_VISIBLE_KEY";

export const FALLBACK_IMAGES = {
  LLAMA: "https://dl-fixed-assets.s3.eu-central-1.amazonaws.com/LOGO_LLAMA.jpg",
  RESEARCH:
    "https://dl-fixed-assets.s3.eu-central-1.amazonaws.com/LOGO_RESEARCH.jpg",
};

export const FIXED_ASSETS = {
  LLAMA_DESK:
    "https://dl-fixed-assets.s3.eu-central-1.amazonaws.com/llama-desk.png",
  LOGO_DLNEWS:
    "https://dl-fixed-assets.s3.eu-central-1.amazonaws.com/LOGO_DLNEWS.png",
};

export const ETF_COLUMN_NAMES = {
  issuer: "Issuer",
  ticker: "Ticker",
  netAssets: "AUM",
  price: "Price",
  custodian: "Custodian",
  nextDeadline: "Next Deadline",
  finalDeadline: "Final Deadline",
} as const;

export const SCREEN_SIZES = {
  XS: 320,
  XS_SM: 425,
  SM: 640,
  MD: 768,
  LG: 1024,
  LG_XL: 1175,
  XL: 1280,
  XL_XXL: 1440,
  XXL: 1536,
} as const;

export const WEEK_DAYS: Record<
  string,
  { name: string; key: string; order: number }
> = {
  "1": { name: "Monday", key: "monday", order: 1 },
  "2": { name: "Tuesday", key: "tuesday", order: 2 },
  "3": { name: "Wednesday", key: "wednesday", order: 3 },
  "4": { name: "Thursday", key: "thursday", order: 4 },
  "5": { name: "Friday", key: "friday", order: 5 },
  "6": { name: "Saturday", key: "saturday", order: 6 },
  "7": { name: "Sunday", key: "sunday", order: 7 },
} as const;

export const SUBTYPES: Record<
  "MAIN" | "NEWS" | "RESEARCH" | "LEGAL" | "SYSTEM",
  {
    ID: string;
    SLUG: string;
    NAME: string;
    TITLE: string;
    SHORT: string;
  }
> = {
  MAIN: {
    ID: "684aaabcc107f95de7aab4a3",
    SLUG: "main",
    NAME: "Main",
    TITLE: "Main",
    SHORT: "MN",
  },
  NEWS: {
    ID: "684aaabcc107f95de7aab4a4",
    SLUG: "articles",
    NAME: "News",
    TITLE: "DL News",
    SHORT: "DLN",
  },
  RESEARCH: {
    ID: "684aaabcc107f95de7aab4a5",
    SLUG: "research",
    NAME: "Research",
    TITLE: "DL Research",
    SHORT: "DLR",
  },
  LEGAL: {
    ID: "684aa71bc107f95de7aab49f",
    SLUG: "legal",
    NAME: "Legal",
    TITLE: "Legal",
    SHORT: "DLL",
  },
  SYSTEM: {
    ID: "68947931949092bc3fb1382d",
    TITLE: "System",
    SLUG: "system",
    NAME: "System",
    SHORT: "SYS",
  },
} as const;

export const VERTICALS: Record<
  | "MAIN"
  | "DEFI"
  | "REGULATION"
  | "MARKETS"
  | "WEB3"
  | "SNAPSHOT"
  | "PEOPLE_CULTURE"
  | "DEALS"
  | "LLAMA_U"
  | "SPONSORED"
  | "OPINION"
  | "INTRODUCING"
  | "INTERVIEWS"
  | "REPORTS"
  | "PARTNERS"
  | "ROUND_TABLES"
  | "PRESS_RELEASE",
  {
    ID: string;
    NAME: string;
    TITLE: string;
    DESCRIPTION: string;
    SLUG: string;
    SUBTYPE_ID: string;
  }
> = {
  MAIN: {
    ID: "684aaaf4c107f95de7aab4a8",
    NAME: "Main",
    SLUG: "main",
    SUBTYPE_ID: SUBTYPES.MAIN.ID,
    TITLE: "",
    DESCRIPTION: "",
  },

  DEFI: {
    ID: "684aad1fc107f95de7aab4af",
    NAME: "DeFi",
    SLUG: "defi",
    SUBTYPE_ID: SUBTYPES.NEWS.ID,
    TITLE:
      "Latest updates on hacks, raises, volumes of decentralised finance protocols",
    DESCRIPTION:
      "Latest news, updates, investigations and exclusive analysis on hacks, raises, volumes, total value locked of decentralised finance protocols",
  },
  REGULATION: {
    ID: "684aad1fc107f95de7aab4b0",
    NAME: "Regulation",
    SLUG: "regulation",
    SUBTYPE_ID: SUBTYPES.NEWS.ID,
    TITLE: "Crypto tax, regulation and crypto legislation updates",
    DESCRIPTION:
      "Latest news, updates, investigations and exclusive analysis on cryptocurrency tax, regulation and crypto legislation",
  },
  MARKETS: {
    ID: "684aad1fc107f95de7aab4b1",
    NAME: "Markets",
    SLUG: "markets",
    SUBTYPE_ID: SUBTYPES.NEWS.ID,
    TITLE:
      "Real-time prices of Bitcoin, Ethereum, Dogecoin and more top cryptocurrencies",
    DESCRIPTION:
      "Latest news, updates, investigations and exclusive analysis on cryptocurrency markets along with real-time prices of Bitcoin, Ethereum, Dogecoin and more top cryptocurrencies",
  },
  WEB3: {
    ID: "684aad1fc107f95de7aab4b2",
    NAME: "Web3",
    SLUG: "web3",
    SUBTYPE_ID: SUBTYPES.NEWS.ID,
    TITLE: "Gaming, the metaverse and NFTs",
    DESCRIPTION:
      "Latest news, updates, investigations and exclusive analysis on gaming, the metaverse and NFTs",
  },
  SNAPSHOT: {
    ID: "684aad1fc107f95de7aab4b3",
    NAME: "Snapshot",
    SLUG: "snapshot",
    SUBTYPE_ID: SUBTYPES.NEWS.ID,
    TITLE: "A daily update on the biggest news in crypto",
    DESCRIPTION:
      "Latest news, updates, investigations and exclusive analysis on the biggest news in decentralised finance and cryptocurrency",
  },
  PEOPLE_CULTURE: {
    ID: "684aad1fc107f95de7aab4b4",
    NAME: "People & Culture",
    SLUG: "people-culture",
    SUBTYPE_ID: SUBTYPES.NEWS.ID,
    TITLE: "Profiles, trends and job moves of biggest names in crypto and DeFi",
    DESCRIPTION:
      "Latest news, updates, investigations and exclusive analysis on profiles, trends and job moves of biggest names in cryptocurrency and decentralised finance",
  },
  DEALS: {
    ID: "684aad1fc107f95de7aab4b5",
    NAME: "Deals",
    SLUG: "deals",
    SUBTYPE_ID: SUBTYPES.NEWS.ID,
    TITLE: "Financial technology startups, venture capital and fund raisings",
    DESCRIPTION:
      "Latest news, updates, investigations and exclusive analysis on financial technology startups, venture capital and fund raisings",
  },
  LLAMA_U: {
    ID: "684aad1fc107f95de7aab4b6",
    NAME: "Llama U",
    SLUG: "llama-u",
    SUBTYPE_ID: SUBTYPES.NEWS.ID,
    TITLE: "Understand cryptocurrencies, blockchain and decentralised finance",
    DESCRIPTION:
      "Learn about the basics and fundamentals of cryptocurrencies, blockchain technology and decentralised finance",
  },
  OPINION: {
    ID: "684aad1fc107f95de7aab4b7",
    NAME: "Opinion",
    SLUG: "opinion",
    SUBTYPE_ID: SUBTYPES.NEWS.ID,
    TITLE: "Opinion columnists and guest essays from the best minds in crypto",
    DESCRIPTION:
      "Latest opinion columnists, guest essays, editorials, op-eds and analysis from the best minds in crypto",
  },

  // EXTERNAL: {
  //   ID: "684aad1fc107f95de7aab4ae",
  //   NAME: "External",
  //   SLUG: "external",
  //   SUBTYPE_ID: SUBTYPES.RESEARCH.ID,
  // },
  // INTERNAL: {
  //   ID: "684aad1fc107f95de7aab4ad",
  //   NAME: "Internal",
  //   SLUG: "internal",
  //   SUBTYPE_ID: SUBTYPES.RESEARCH.ID,
  // },

  INTRODUCING: {
    ID: "68f61c9a39c5976b531735a5",
    NAME: "Introducing",
    SLUG: "introducing",
    SUBTYPE_ID: SUBTYPES.RESEARCH.ID,
    TITLE: "",
    DESCRIPTION: "",
  },
  INTERVIEWS: {
    ID: "68ed017ebe5deae7c6b34c36",
    NAME: "Interviews",
    SLUG: "interviews",
    SUBTYPE_ID: SUBTYPES.RESEARCH.ID,
    TITLE: "",
    DESCRIPTION: "",
  },
  REPORTS: {
    ID: "68ed017ebe5deae7c6b34c37",
    NAME: "Reports",
    SLUG: "reports",
    SUBTYPE_ID: SUBTYPES.RESEARCH.ID,
    TITLE: "",
    DESCRIPTION: "",
  },
  PARTNERS: {
    ID: "68ed017ebe5deae7c6b34c38",
    NAME: "Partners",
    SLUG: "partners",
    SUBTYPE_ID: SUBTYPES.RESEARCH.ID,
    TITLE: "",
    DESCRIPTION: "",
  },
  PRESS_RELEASE: {
    ID: "68f61cff39c5976b531735dd",
    NAME: "Press Release",
    SLUG: "press-release",
    SUBTYPE_ID: SUBTYPES.RESEARCH.ID,
    TITLE: "",
    DESCRIPTION: "",
  },
  ROUND_TABLES: {
    ID: "68ed017ebe5deae7c6b34c3a",
    NAME: "Round Tables",
    SLUG: "round-tables",
    SUBTYPE_ID: SUBTYPES.RESEARCH.ID,
    TITLE: "",
    DESCRIPTION: "",
  },
  SPONSORED: {
    ID: "6938456a5d6f8100d9fa645a",
    NAME: "Sponsored",
    SLUG: "sponsored",
    SUBTYPE_ID: SUBTYPES.RESEARCH.ID,
    TITLE: "",
    DESCRIPTION: "",
  },
} as const;

/**
 * NOTE: "insights" is not a VERTICAL, but rather a collection.
 * It is the only collection that needs to be filterable in the search results.
 */
export const RESEARCH_INSIGHTS = "insights";

export const TEMPLATES = {
  ARTICLES: {
    ID: "68ad8b6b70dedc29d95f1a24",
    TITLE: "DL News",
  },
  RESEARCH: {
    ID: "68ad8b7e70dedc29d95f1a2d",
    TITLE: "DL Research",
  },
} as const;

export const STOP_WORDS = new Set([
  "a",
  "an",
  "the",
  "at",
  "by",
  "in",
  "of",
  "on",
  "to",
  "with",
  "and",
  "or",
  "for",
  "but",
  "if",
  "nor",
  "so",
  "yet",
  "I",
  "me",
  "you",
  "he",
  "she",
  "it",
  "we",
  "they",
  "them",
  "us",
  "is",
  "are",
  "was",
  "were",
  "be",
  "been",
  "being",
  "have",
  "has",
  "had",
  "do",
  "does",
  "did",
  "will",
  "shall",
  "should",
  "can",
  "could",
  "may",
  "might",
  "must",
  "when",
  "why",
  "!",
  "?",
  ".",
  ",",
  ":",
  ";",
  "-",
  "_",
  "(",
  ")",
  "[",
  "]",
  "{",
  "}",
  "'",
  '"',
]);

export const NEWSLETTERS_CONFIG = [
  {
    id: "pub_8f93056d-017a-44ab-942f-389639183d1b",
    name: "The Guidance",
    description: "Your weekly guide to crypto regulation",
    img: "https://dl-fixed-assets.s3.eu-central-1.amazonaws.com/NEWSLETTER_1.jpg",
    day: "Mondays",
  },
  {
    id: "pub_6908cae2-450a-4e92-be5d-fb3a5d3cfdeb",
    name: "The Decentralised",
    description: "Your weekly guide to the world of DeFi",
    img: "https://dl-fixed-assets.s3.eu-central-1.amazonaws.com/NEWSLETTER_2.jpg",
    day: "Tuesdays",
  },
  {
    id: "pub_8013c2fc-b2ac-4de7-8db6-4044e3ae835b",
    name: "The Roundup",
    description: "A recap of the week's top stories",
    img: "https://dl-fixed-assets.s3.eu-central-1.amazonaws.com/NEWSLETTER_3.jpg",
    day: "Fridays",
  },
] as const;

export const WORKFLOWS = {
  Draft: "draft",
  Published: "published",
} as const;

export const WORKFLOW_ACTIONS = {
  Publish: "Publish",
  Update: "Update",
  Unpublish: "Unpublish",
} as const;

export const SOCKET_EVENTS = {
  STORY_LOCKED: "story-locked",
  STORY_UNLOCKED: "story-unlocked",

  LOCK_STORY: "lock-story",
  UNLOCK_STORY: "unlock-story",
  REQUEST_LOCK_STORY: "request-lock-story",
  REPLY_TO_LOCK_STORY: "reply-to-lock-story",

  ALLOW_RELEASE_STORY_LOCK: "allow-release-story-lock",
} as const;

export const COMMON_RESOURCES = {
  USERS: {
    ROUTE: "users",
    CMS: {
      SHOW_ROLE: true,
      SHOW_PAGE: true,
      TITLE: "Users",
    },
  },
  ROLES: {
    ROUTE: "roles",
    CMS: {
      SHOW_ROLE: true,
      SHOW_PAGE: true,
      TITLE: "Roles",
    },
  },
  JOBS: {
    ROUTE: "jobs",
    CMS: {
      SHOW_ROLE: true,
      SHOW_PAGE: true,
      TITLE: "Jobs",
    },
  },

  TAGS: {
    ROUTE: "tags",
    CMS: {
      SHOW_ROLE: true,
      SHOW_PAGE: true,
      TITLE: "Related topics",
    },
  },
  ASSETS: {
    ROUTE: "assets",
    CMS: {
      SHOW_ROLE: true,
      SHOW_PAGE: true,
      TITLE: "Assets",
    },
  },
  STORIES: {
    ROUTE: "stories",
    CMS: {
      SHOW_ROLE: true,
      SHOW_PAGE: true,
      TITLE: "Articles",
    },
  },
  SUBTYPES: {
    ROUTE: "subtypes",
    CMS: {
      SHOW_ROLE: false,
      SHOW_PAGE: false,
      TITLE: "Subtypes",
    },
  },
  VERTICALS: {
    ROUTE: "verticals",
    CMS: {
      SHOW_ROLE: false,
      SHOW_PAGE: false,
      TITLE: "Verticals",
    },
  },
  TEMPLATES: {
    ROUTE: "templates",
    CMS: {
      SHOW_ROLE: true,
      SHOW_PAGE: true,
      TITLE: "Templates",
    },
  },
  COLLECTIONS: {
    ROUTE: "collections",
    CMS: {
      SHOW_ROLE: true,
      SHOW_PAGE: true,
      TITLE: "Collections",
    },
  },
  EVENTS: {
    ROUTE: "events",
    CMS: {
      SHOW_ROLE: true,
      SHOW_PAGE: true,
      TITLE: "Events",
    },
  },
  REPORTS: {
    ROUTE: "reports",
    CMS: {
      SHOW_ROLE: true,
      SHOW_PAGE: true,
      TITLE: "Reports",
    },
  },

  HELP: {
    ROUTE: "help",
    CMS: {
      SHOW_ROLE: true,
      SHOW_PAGE: false,
      TITLE: "Help",
    },
  },
  CONFIGURATIONS: {
    ROUTE: "configurations",
    CMS: {
      SHOW_ROLE: true,
      SHOW_PAGE: false,
      TITLE: "Configurations",
    },
  },
  TOOLS: {
    ROUTE: "tools",
    CMS: {
      SHOW_ROLE: true,
      SHOW_PAGE: false,
      TITLE: "Tools",
    },
  },
  ANALYTICS: {
    ROUTE: "analytics",
    CMS: {
      SHOW_ROLE: false,
      SHOW_PAGE: false,
      TITLE: "Analytics",
    },
  },
} as const;

export const STATUSES = {
  ACTIVE: "active",
  INACTIVE: "inactive",
} as const;

export const COLLECTION_IDS = {
  // NEWS
  TOP_STORIES_AND_ARCHIVES_COLLECTION_ID: {
    SYSTEM_ID: "68dfbb27bfd0cfb96db8d280",
    ARC_ID: "RN3KYRZYGJBHZGP6KMDKPWDLJ4",
  },
  EDITORS_PICK_COLLECTION_ID: {
    SYSTEM_ID: "68dfbb27bfd0cfb96db8d26c",
    ARC_ID: "XYUDZXMOYZDX5L4PE72MQNMCFY",
  },
  SNAPSHOT_COLLECTION_ID: {
    SYSTEM_ID: "68dfbb27bfd0cfb96db8d273",
    ARC_ID: "YOGQDIOK3JGL3JQED3GTBO7IKE",
  },
  OPINION_COLLECTION_ID: {
    SYSTEM_ID: "68dfbb27bfd0cfb96db8d270",
    ARC_ID: "WTJRDTKPNBDJ7JVXYJJZTJQCKM",
  },
  FEATURE_OF_THE_WEEK_COLLECTION_ID: {
    SYSTEM_ID: "68dfbb27bfd0cfb96db8d272",
    ARC_ID: "MFHOQVVPLFFAFP3SRVAWL2G3KQ",
  },
  DONT_MISS_FROM_DLR: {
    SYSTEM_ID: "69e9ebe37aa125b01f1df1b6",
    ARC_ID: "",
  },
  LATEST_INTERVIEWS: {
    SYSTEM_ID: "69e9ebf67aa125b01f1df1b7",
    ARC_ID: "",
  },

  // RESEARCH
  RESEARCH_SPOTLIGHT_COLLECTION_ID: {
    SYSTEM_ID: "68dfbb27bfd0cfb96db8d26f",
    ARC_ID: "YNTCE4FCWBGQ3MUEHMTONKHCA4",
  },
  RESEARCH_INTERVIEWS_COLLECTION_ID: {
    SYSTEM_ID: "68dfbb27bfd0cfb96db8d271",
    ARC_ID: "PQIRPHOTRJC4VO25DWQSTM4PXM",
  },
  RESEARCH_INTRODUCING_COLLECTION_ID: {
    SYSTEM_ID: "6984c7680c3da8b972e9b565",
    ARC_ID: "",
  },
  RESEARCH_INSIGHTS_COLLECTION_ID: {
    SYSTEM_ID: "693556ad744b9069e3592e6e",
    ARC_ID: "Q7FQLY7UYVHEZEQKTHUCDZJELQ",
  },
  RESEARCH_COLLECTION_COLLECTION_ID: {
    SYSTEM_ID: "69bc2f4f6062eef44e0cf782",
    ARC_ID: "",
  },
  RESEARCH_LATEST_COLLECTION_ID: {
    SYSTEM_ID: "697a26f4dca2ac7465f8a087",
    ARC_ID: "",
  },
  RESEARCH_PARTNERS_COLLECTION_ID: {
    SYSTEM_ID: "",
    ARC_ID: "WVKWWHXLQVFQ3CC3IY5BTTQWNY",
  },

  REPORTS_MAIN: {
    SYSTEM_ID: "69281e2cf995eef014e538ec",
    ARC_ID: "",
  },
  REPORTS_HERO: {
    SYSTEM_ID: "691ebba72208b7a256558685",
    ARC_ID: "",
  },
  REPORTS_HIGHLIGHTED: {
    SYSTEM_ID: "6997c9607fc0eacdb07359aa",
    ARC_ID: "",
  },

  EVENTS: {
    SYSTEM_ID: "6932e027205cc2cf09bb0762",
    ARC_ID: "",
  },

  NEWSROOM_TEAM: {
    SYSTEM_ID: "69455ef39c7f10c29c692037",
    ARC_ID: "",
  },
  BUSINESS_TEAM: {
    SYSTEM_ID: "69456664c15be9dafed3da93",
    ARC_ID: "",
  },
  RESEARCH_TEAM: {
    SYSTEM_ID: "69456695c15be9dafed3daa8",
    ARC_ID: "",
  },
} as const;

export const TEAMS = {
  BUSINESS: {
    SLUG: "business",
    NAME: "Business",
  },
  RESEARCH: {
    SLUG: "research",
    NAME: "Research",
  },
  NEWSROOM: {
    SLUG: "newsroom",
    NAME: "Newsroom",
  },
} as const;

export const VALUES = {
  EMPTY_FIELD: "-",
};

export const USERS = {
  TECHNICAL_USER: {
    NAME: "Technical User",
    SLUG: "technical",
  },
  RESEARCH_AUTHOR: {
    NAME: "DL Research",
    SLUG: "dlresearch",
  },
  GUEST_AUTHOR: {
    NAME: "Guest Author",
    SLUG: "guest-author",
  },
} as const;

export const ERROR_CAUSES = {
  AUTH_BLOCKED: "AUTH_BLOCKED",

  ACCOUNT_NOT_FOUND: "ACCOUNT_NOT_FOUND",
  ACCOUNT_HAS_NO_PASSWORD: "ACCOUNT_HAS_NO_PASSWORD",

  TWO_FACTOR_NOT_SETUP: "TWO_FACTOR_NOT_SETUP",
  TWO_FACTOR_NOT_VERIFIED: "TWO_FACTOR_NOT_VERIFIED",
  TWO_FACTOR_ALREADY_SETUP: "TWO_FACTOR_ALREADY_SETUP",
  TWO_FACTOR_INVALID_VERIFICATION_CODE: "TWO_FACTOR_INVALID_VERIFICATION_CODE",

  CREDENTIALS_EXPIRED: "CREDENTIALS_EXPIRED",
  CREDENTIALS_INVALID: "CREDENTIALS_INVALID",

  ACTION_TAKER_NOT_STORY_LOCKER: "ACTION_TAKER_NOT_STORY_LOCKER",
} as const;

export const DATE_RANGE_VALUES = {
  PAST_WEEK: "now-1w/d",
  PAST_MONTH: "now-1M/d",
  PAST_3_MONTHS: "now-3M/d",
  PAST_6_MONTHS: "now-6M/d",
  PAST_YEAR: "now-1y/d",
} as const;

export const VALIDATION_REGEXES = {
  PASSWORD:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/,
} as const;
